import React, { useState } from 'react';
import style from '../css/Location.module.css';
import bangalore from '../images/bangalore.png';
import dhanbad from '../images/dhanbad.png';

const Location = ({ onLocationSelect }) => {
	const [location, setLocation] = useState('');

	const handleLocationChange = (selectedLocation) => {
		setLocation(selectedLocation);
		onLocationSelect(selectedLocation);
	};

	return (
		<div className={style.container}>
			<div className={style.card}>
				<h1 className={style.title}>Choose Your Location</h1>
				<div className={style.buttonGroup}>
					<div onClick={() => handleLocationChange('Bangalore')}>
						<img src={bangalore} alt="" className={style.image} />
						<button
							onClick={() => handleLocationChange('Bangalore')}
							className={style.button}
						>
							Bangalore
						</button>
					</div>

					<div onClick={() => handleLocationChange('Dhanbad')}>
						<img src={dhanbad} alt="" className={style.image} />
						<button
							onClick={() => handleLocationChange('Dhanbad')}
							className={style.button}
						>
							Dhanbad
						</button>
					</div>
				</div>
				{location && (
					<p className={style.selected}>Selected Location: {location}</p>
				)}
			</div>
		</div>
	);
};

export default Location;
